<template>
    <div class="min-h-screen bg-gray-100">
        <div id="dropdown-teleport-target" />
        <nav class="mb-6 bg-white px-2 py-4 shadow-sm print:hidden">
            <div class="mx-1 flex items-center justify-between 2xl:container">
                <div class="flex items-center">
                    <InertiaLink :href="route('landing')" class="mr-4 text-lg">
                        {{ settings.general.site_name }}
                    </InertiaLink>
                    <MainMenu v-if="user" class="hidden flex-wrap items-center gap-y-2 md:flex" />
                </div>

                <Dropdown v-if="user" :auto-close="true" placement="bottom-end" class="md:hidden">
                    <template #default>
                        <div type="button" class="px-2 text-sm text-gray-600">
                            {{ user.name }}
                            <ChevronDownIcon class="inline-block h-4 w-4" />
                        </div>
                    </template>
                    <template #dropdown>
                        <div class="mt-2 flex w-56 flex-col rounded-sm bg-white py-2 shadow-xl">
                            <MainMenu flat class="flex flex-col" />
                            <div class="my-2 h-px w-full bg-gray-200" />
                            <UserMenu />
                        </div>
                    </template>
                </Dropdown>
                <Dropdown v-if="user" :auto-close="true" placement="bottom-end" class="hidden md:block">
                    <template #default>
                        <div type="button" class="flex-none px-2 text-sm text-gray-600">
                            {{ user.name }}
                            <ChevronDownIcon class="inline-block h-4 w-4" />
                        </div>
                    </template>
                    <template #dropdown>
                        <div class="mt-2 flex min-w-40 flex-col rounded-sm bg-white py-2 shadow-xl">
                            <UserMenu />
                        </div>
                    </template>
                </Dropdown>
            </div>
        </nav>

        <div class="mx-1 px-2 2xl:container">
            <slot></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ChevronDownIcon } from '@heroicons/vue/24/solid';
import { Link as InertiaLink, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

import Dropdown from '@/Components/Dropdown.vue';
import MainMenu from '@/Components/MainMenu.vue';
import UserMenu from '@/Components/UserMenu.vue';
import type { AuthenticatedPageProps } from '@/types/inertia';

window.layoutLoaded = true;

const page = usePage<AuthenticatedPageProps>();
const user = computed(() => page.props.auth.user);
const settings = computed(() => page.props.settings);
</script>
